/**
 * Component Registry for Towns at River's Edge/Lofts at Rivers Edge
 * 
 * Inherits from @vibesites-apartment-management-consultants/theme-theme-homestead-milburn and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-apartment-management-consultants/theme-theme-homestead-milburn/registry';
import { FloorPlansGrid } from './components/FloorPlansGrid';
import { Header } from './components/Header';
import { PetPolicy } from './components/PetPolicy';
import { PropertyOverview } from './components/PropertyOverview';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  FloorPlansGrid,
  Header,
  PetPolicy,
  PropertyOverview,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
